<div class="modal-body" [formGroup]="authorizationForm">
  <app-message *ngIf="errorObject.isError" [message]="errorObject.message" [type]="errorObject.type"></app-message>
  <div class="panel-item">
    <label class="panel-label">Телефон</label>
    <input formControlName="login" prefix="+7" mask=" (000) 000 00 00" type="text" class="panel-input login" readonly>
  </div>

  <div class="panel-item password">
    <label class="panel-label">Пароль</label>
    <input formControlName="password" type="{{isShowPassword ? 'text' : 'password'}}" class="panel-input" placeholder="Введите пароль">
    <button class="btn-group-eye" (click)="isShowPassword = !isShowPassword">
      <i class="pi {{isShowPassword ? 'pi-eye' : 'pi-eye-slash'}}"></i>
    </button>
  </div>

  <div class="panel-item">
    <button class="panel-btn-link" type="button" (click)="changeStepEvent('resetPassword')">Забыли пароль?</button>
  </div>
  <div class="panel-action-btns">
    <app-button
    [buttonClass]="'big-gray-light'"
    [text]="'Назад'"
    (buttonClick)="changeStepEvent('login')"
    [styleInline]="{ 'height': '100%' }"
  ></app-button>
    <app-button
    [buttonClass]="'big-purple-gradient'"
    [text]="'Войти'"
    [disabled]="isSendCredentials"
    (buttonClick)="confirmCredentials()"
    [styleInline]="{ 'height': '100%', 'width': '100%' }"
  ></app-button>
  </div>
</div>
